import { Component, Injector, forwardRef, OnDestroy, EventEmitter, Output, ChangeDetectorRef, AfterViewChecked, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';

import { Subject } from 'rxjs';

import { InputBase } from '../../components/form/base/input-base';

@Component({
    selector: 'aa-rating2',
    templateUrl: './rating2.component.html',
    styleUrls: [
        './rating2.component.scss',
        '../../components/form/controls/input/input.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => Rating2Component),
            multi: true,
        }],
    standalone: false
})
export class Rating2Component extends InputBase<string> implements OnInit, AfterViewChecked, OnDestroy
{
    @Input() id: string;
    @Input() rating: number = 0;
    @Output() ratingClick: EventEmitter<any> = new EventEmitter<any>();
    inputName: string;

    private static identifier: number = 0;
    private destroyator = new Subject();
    public fieldId: string = `rating2-${Rating2Component.identifier++}-id`;
    public formGroup: UntypedFormGroup;
    @Output() select: EventEmitter<string> = new EventEmitter<string>();

    constructor (
        injector: Injector,
        private changeDetectorRef: ChangeDetectorRef
    )
    {
        super(injector);
        this.formGroup = new UntypedFormGroup(
            {
                formControlName: new UntypedFormControl('', this.required ? Validators.required : [])
            });
    }

    ngOnInit ()
    {
        this.inputName = `rating_${this.id}`;
    }

    onClick (rating: number): void
    {
        this.rating = rating;
        this.ratingClick.emit({
            id: this.id,
            rating: rating
        });
    }

    ngAfterViewChecked ()
    {
        this.formGroup.get('formControlName').setValue(this.value);
        this.changeDetectorRef.detectChanges();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    onSelected ()
    {
        this.value = this.formGroup.get('formControlName').value;
        this.select.emit(this.value);
    }
}
